module.exports = __webpack_public_path__ + "static/media/logo_horizontal_lilla.6a7b1e83.svg";